import { Product } from './types';

/**
 * Checks if a product should be visible on the ordering page.
 * A product is visible if its admin 'available' flag is true.
 * This includes sold-out items (they appear grayed out with a "Sold Out" overlay).
 */
export function isProductVisibleOnMenu(product: Product): boolean {
    return product.available;
}

/**
 * Checks if a product is actually orderable (can be added to cart).
 * A product is orderable if:
 * 1. The 'available' flag is true
 * 2. It has stock > 0, OR has no stock tracking, OR has allowStockException
 */
export function isProductAvailableForOrdering(product: Product): boolean {
    const availableStock = product.availableStock ?? null;
    const isOutOfStock = availableStock !== null && availableStock <= 0;
    return product.available && (!isOutOfStock || !!product.allowStockException);
}

/**
 * Checks if a product is sold out (visible but not orderable).
 * Sold out means: available=true, stock tracked, stock<=0, no stock exception.
 */
export function isProductSoldOut(product: Product): boolean {
    const availableStock = product.availableStock ?? null;
    const isOutOfStock = availableStock !== null && availableStock <= 0;
    return product.available && isOutOfStock && !product.allowStockException;
}
